
import { ref, onMounted, reactive, defineComponent } from 'vue'
import DataTable from '@/views/components/table/HjpDataTable.vue'
import Form from './Form.vue'

export default defineComponent({
  components: {
    DataTable,
    Form
  },
  setup() {
    const tabelParams = reactive({
      endpoint: '/talent/v1/documentTypes',
      headerTitle: 'Master Dokumen',
      buttonTitle: '',
      editTitle: 'Edit',
      deleteTitle: 'Hapus',
      confirmDialogDelete: {
        title: 'Hapus Dokumen?',
        subTitle: 'Pastikan Dokumen yang Anda tambahkan sudah sesuai dan tidak ada perubahan ditengah-tengah.',
        btnSubmitTitle: 'Hapus Dokumen',
      },
      columnsTable: [
        {
          field: 'name',
          headerName: 'Nama Dokumen',
          searchable: true,
          fieldSearch: 'name',
          isRender: false
        },
        {
          field: 'description',
          headerName: 'Keterangan',
          searchable: true,
          fieldSearch: 'description',
          isRender: false
        },
        {
          field: 'reminderDaysBeforeExpiry',
          headerName: 'Notifikasi Pengingat',
          searchable: true,
          fieldSearch: 'reminderDaysBeforeExpiry',
          isRender: true
        },
      ]
    })
    // const slotBank = 'MsBank.Name'
    // const slotChannelBank = 'MsChannelBanks.OaAccount'
    // const getBankChannelId = (data: any) => {
    //   console.log('data', data)
    // }
    return {
      tabelParams
    }
  }
})
